module.exports = __webpack_public_path__ + "img/teacher-light.3022145e.png";